// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDialog {
  display: flex;
  flex-direction: column;
  padding: 1rem;
}
.mainDialog .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mainDialog .amountBox {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #6A6E73;
  border-radius: 0.5rem;
  padding: 0.3rem;
  margin-top: 0.5rem;
}
.mainDialog .cardActionArea {
  border-radius: 0.5rem;
}
.mainDialog .depositBox {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1rem 0.4rem;
  border-radius: 0.5rem;
  cursor: pointer;
}
.mainDialog .unit {
  font-size: 0.6rem;
  color: #6A6E73;
  margin-right: 0.2rem;
}
.mainDialog .footer {
  display: flex;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Wallet/DepositDialog/deposit.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAAR;AAGI;EACI,qBAAA;AADR;AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;AADR;AAII;EACI,iBAAA;EACA,cAAA;EACA,oBAAA;AAFR;AAII;EACI,aAAA;EACA,SAAA;AAFR","sourcesContent":[".mainDialog {\n    display: flex;\n    flex-direction: column;\n    padding: 1rem;\n\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    }\n\n    .amountBox {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border: 1px solid #6A6E73;\n        border-radius: 0.5rem;\n        padding: 0.3rem;\n        margin-top: 0.5rem;\n    }\n\n    .cardActionArea {\n        border-radius: 0.5rem;\n    }\n    .depositBox {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0.1rem 0.4rem;\n        border-radius: 0.5rem;\n        cursor: pointer;\n    }\n\n    .unit {\n        font-size: 0.6rem;\n        color: #6A6E73;\n        margin-right: 0.2rem;\n    }\n    .footer {\n        display: flex;\n        gap: 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
